// extracted by mini-css-extract-plugin
var _1 = "ReadonlyOrganizationSummary-module__animatedBackground--Lroph";
var _2 = "ReadonlyOrganizationSummary-module__container--zCO__";
var _3 = "ReadonlyOrganizationSummary-module__editor--wv_oX";
var _4 = "ReadonlyOrganizationSummary-module__header--EVryK";
var _5 = "ReadonlyOrganizationSummary-module__open--kLc7Q";
var _6 = "ReadonlyOrganizationSummary-module__overflowMenu--OnaGu";
export { _1 as "animatedBackground", _2 as "container", _3 as "editor", _4 as "header", _5 as "open", _6 as "overflowMenu" }
